import { JSONSchema7 } from 'json-schema';
import { types as commonTypes } from '@sitebuilder/common';
import templateView from './templateView';

const defaultQuery = `{
    children: webProfiles {
      id
    }
}`;

const schema: JSONSchema7 = {
    title: 'Repeater',
    type: 'object',
    required: [],
    properties: {
        classnames: { type: 'string', default: '' },
        dataSource: {
            type: 'string',
            description: 'Data source',
            default: '',
        },
        expression: {
            type: 'string',
            description: 'A graphql query',
            default: defaultQuery,
        },
        transform: {
            type: 'string',
            description: 'A transform function to transform the graphql query results',
            default: '',
        },
        placeHolderExpression: {
            type: 'string',
            description: 'A transform function to transform the graphql query results',
            default: '',
        },
        exports: {
            type: 'array',
            title: 'list of exports',
            items: {
                type: 'object',
                properties: {
                    name: {
                        type: 'string',
                        title: 'Name',
                    },
                    value: {
                        type: 'string',
                        title: 'value',
                    },
                },
            },
        },
    },
};

const repeater: commonTypes.IWidget = {
    // without default
    schema,
    uiSchema: {
        expression: {
            'ui:widget': 'JSEditor',
        },
        transform: {
            'ui:widget': 'JSEditor',
        },
    },
    templateView,
    id: 'Repeater',
    group: 'data',
    contentPlaceHolders: ['children'],
    initialData: () => ({
        classnames: '',
        expression: defaultQuery,
        exports: [],
    }),
};

export default repeater;
